<template>
    <v-container>
        <v-row>
            <v-col>
                <v-toolbar rounded="" color="secondary" dense  elevation="1">            
                    <v-breadcrumbs class="ms-n6" :items="[{text: 'Warehouse & Inventory'}, {text: 'Measure Unit'}, {text: 'Edit Measure Unit'}]" large></v-breadcrumbs>
                    <v-spacer></v-spacer>
                </v-toolbar>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" md="6">
                <v-sheet elevation="1" rounded="">
                    <v-toolbar flat color="secondary">
                        <v-toolbar-title>
                            Edit Measure Unit
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-toolbar-items>
                            <PIconBtn icon="mdi-content-save" tooltip="Save" @click="handleSave"/>
                            <PIconBtn icon="mdi-delete" tooltip="Delete" @click="handleDelete" v-if="hasPermission(perm.measure_unit.delete)"/>
                            <PIconBtn icon="mdi-format-list-text" tooltip="List" @click="navigateToList" />
                            <PIconBtn icon="mdi-cancel" tooltip="Cancel" @click="handleCancel"/>
                        </v-toolbar-items>
                    </v-toolbar>
                    <v-progress-linear indeterminate v-if="loading"/>
                    <v-divider></v-divider>
                    <MeasureUnitForm
                        v-if="!measureUnitLoading"
                        ref="form" 
                        v-model="data" 
                        class="pa-3"
                    />
                    <div v-else class="pa-3"> 
                        <v-col cols="12" md="4" >
                            <v-skeleton-loader
                                type="text"
                            >
                            </v-skeleton-loader>
                        </v-col>
                        <v-col cols="12" md="4" >
                            <v-skeleton-loader
                                type="text"
                            >
                            </v-skeleton-loader>
                        </v-col>
                    </div>
                </v-sheet>
            </v-col>
        </v-row>
        <PAlert v-bind="alert" v-model="alert.value"/>
    </v-container>
</template>

<script>
import PAlert from './../../components/common/PAlert'
import PIconBtn from './../../components/common/PIconBtn'
import MeasureUnitForm from './../../components/warehouse/MeasureUnitForm';
import { mapActions, mapGetters } from 'vuex';
import permissions from './../../data/permissions';
export default {
    name: "MeasureUnitEditView",
    components: {
        MeasureUnitForm,
        PIconBtn,
        PAlert
    },
    data() {
        return {
            id: null,
            data: null,
            measureUnitLoading: false,
            alert: {
                title: "Alert",
                content: "Are you sure you want to save",
                value: false,
                callback: null
            },
            loading: false,
            perm: permissions
        }
    },
    computed: {
        ...mapGetters({ hasPermission: "authentication/hasPermission"})
    },
    methods: {
        ...mapActions({
            snackbar: "ui/snackbar/show",
            findByID: "warehouse/measureUnit/findByID",
            update: "warehouse/measureUnit/update",
            remove: "warehouse/measureUnit/remove"
        }),
        getMeasureUnit() {
            this.measureUnitLoading = true
            this.findByID(this.id).then(response => {
                this.data = response.data 
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.measureUnitLoading = false;
            })
        },
        handleSave() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to Save?", callback: this.save};
        },
        save(){
            this.loading = true 
            this.update(this.data).then(response => {
                this.$router.push({ name: "MeasureUnitDisplay", params: { id: response.data.id } })
                this.snackbar({text: "Measure Unit Updated", color: "success"})
            }).catch( error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.loading = true
            })
        },
        handleDelete() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to delete?", callback: this.removeMeasureUnit};
        },
        removeMeasureUnit() {
            this.loading = true
            this.remove(this.data).then(() => {
                this.snackbar({color: 'success', text: "Measure Unit Deleted" })
                this.$router.push({ name: "MeasureUnitList" })
            }).catch(error => {
                let message = error.response ? error.response.data.message : error
                this.snackbar({color: 'error', text: message })
            }).finally(() => {
                this.loading = false;
            })
        },
        navigateToList() {
            this.$router.push({ name: "MeasureUnitList"})
        },
        handleCancel() {
            this.alert = {...this.alert, value: true, content: "Are you sure you want to discard changes?", callback: this.cancel};
        },
        cancel() {
            this.$router.push({ name: "MeasureUnitDisplay", params: { id: this.id } })
        }
    },
    mounted() {
        this.id = this.$route.params.id
        this.getMeasureUnit()
    },
    beforeRouteUpdate(from, to, next) {
        this.id = to.params.id;
        this.getMeasureUnit();
        next()
    }
}
</script>

<style>

</style>